import { getProcessList, reportMessageForPage } from '@/api/processList.js'
import lodash from 'lodash'

export const service = {
  getProcessList(data) {
    // const params = {
    //   process_base_status: data.process_base_status
    //   // process_base_status_bit: data.type
    // }
    return new Promise((resolve, reject) => {
      getProcessList(data)
        .then((response) => {
          if (response) {
            const data = lodash.cloneDeep(response.records) || []
            for (let i = 0; i < data.length; i++) {
              if (data[i].process_base_drafter) {
                // data[i].process_base_drafter = data[i].process_base_drafter
                data[i].drafter_name = data[i].process_base_drafter.user_nick_name
              }
              // if (data[i].process_base_status) {
              //   if (data[i].process_base_status === 'Approval') {
              //     data[i].process_status = '待审批'
              //   } else if (data[i].process_base_status === 'Draft') {
              //     data[i].process_status = '申请中'
              //   } else if (data[i].process_base_status === 'Finish') {
              //     data[i].process_status = '待发放'
              //   } else if (data[i].process_base_status === 'ReturnDraft') {
              //     data[i].process_status = '退回（申请中）'
              //   } else if (data[i].process_base_status === 'Termination') {
              //     data[i].process_status = '终止'
              //   } else if (data[i].process_base_status === 'IsFinished') {
              //     data[i].process_status = '待发放'
              //   } else if (data[i].process_base_status === 'Finished') {
              //     data[i].process_status = '已完成'
              //   }
              // }

              if (data[i].process_base_status) {
                if (data[i].process_base_status === 'Approval') {
                  if (data[i].process_config_type === 'projectFund' || data[i].process_config_type === 'projectActivity') {
                    if (data[i].process_base_deal_date == null) {
                        if (data[i].process_config_step === '1') {
                            data[i].process_status = '待申报'
                        }
                        if (data[i].process_config_step === '2') {
                            data[i].process_status = '待复核'
                        }
                        if (data[i].process_config_step === '3') {
                            data[i].process_status = '执行中'
                        }
                    } else {
                        if (data[i].process_config_step === '3') {
                            data[i].process_status = '结项'
                        }
                    }
                  } else {
                    data[i].process_status = '待审批'
                  }
                } else if (data[i].process_base_status === 'Draft') {
                  data[i].process_status = '申请中'
                } else if (data[i].process_base_status === 'Finish') {
                  if (data[i].process_config_type === 'individualCase') {
                    data[i].process_status = '待发放'
                  }
                  if (data[i].process_config_type === 'reportMessage' || data[i].process_config_type === 'internalDocuments') {
                    data[i].process_status = '已完成'
                  }
                } else if (data[i].process_base_status === 'ReturnDraft') {
                  data[i].process_status = '退回（申请中）'
                } else if (data[i].process_base_status === 'Termination') {
                  data[i].process_status = '终止'
                } else if (data[i].process_base_status === 'Finished') {
                  data[i].process_status = '已完成'
                }
              }

              // if (data[i].process_base_table_message) {
              //   data[i].process_base_table_message = JSON.parse(data[i].process_base_table_message)
              //   data[i].projectType = data[i].process_base_table_message.project_type ? data[i].process_base_table_message.project_type[0] : ''
              //   data[i].address = data[i].process_base_table_message.project_sponsor
              // }
            }
            data.map((item, index) => {
                if (item.process_status === '待审批') {
                    if ((item.process_base_status === 'Approval' && item.process_config_step === 'street' && item.process_base_status_bit === 0) ||
                        (item.process_base_status === 'Approval' && item.process_config_step === 'Draft' && item.process_base_status_bit === 1)) {
                        item.process_status = '待审批（街镇）'
                    }

                    if ((item.process_base_status === 'Approval' && item.process_config_step === 'street' && item.process_base_status_bit === 1) ||
                        (item.process_base_status === 'Approval' && item.process_config_step === 'districtAndCounty' && item.process_base_status_bit === 0)) {
                        item.process_status = '待审批（区级）'
                    }
                }
                return item
            })
            resolve(data)
          } else {
            resolve([])
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  reportMessageForPage(data) {
    return new Promise((resolve, reject) => {
      reportMessageForPage(data).then((response) => {
        resolve(response || {})
      })
    })
  }
}
